import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  standalone: true,
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'button[ucx-icon-button]',
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss'],
})
export class IconButtonComponent implements OnInit {
  constructor(private sanitizer: DomSanitizer) {}

  @Input()
  imageSource = '';

  @Input()
  altText = 'Send Message Button';

  ngOnInit(): void {
    this.svgSource(this.imageSource);
  }

  svgSource(value) {
    this.imageSource = this.sanitizer.bypassSecurityTrustUrl(value) as string;
  }
}
